var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBundlle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V22C36 25.3137 33.3137 28 30 28H6C2.68629 28 0 25.3137 0 22V6Z",
    fill: "#A2AEDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3858_13066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.875 14.4688V22H23.625C24.4004 22 25.0625 21.3692 25.0625 20.5938V14.4688H19.875Z",
    fill: "#3855B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 14.4688V20.5938C10.9375 21.3692 11.5683 22 12.3438 22H16.125V14.4688H10.9375Z",
    fill: "#3855B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5938 9.75H22.6755C22.973 9.35706 23.1562 8.87337 23.1562 8.34375C23.1562 7.05147 22.1048 6 20.8125 6C19.1768 6 18.7032 7.17828 18 8.96259C17.2968 7.17828 16.8232 6 15.1875 6C13.8952 6 12.8438 7.05147 12.8438 8.34375C12.8438 8.87337 13.027 9.35706 13.3245 9.75H11.4062C10.6308 9.75 10 10.3808 10 11.1562V12.125C10 12.9004 10.6308 13.5312 11.4062 13.5312H16.125V9.75H15.1875C14.4121 9.75 13.7812 9.11919 13.7812 8.34375C13.7812 7.56831 14.4121 6.9375 15.1875 6.9375C16.1483 6.9375 16.4216 7.51381 17.1399 9.33619C17.1899 9.46344 17.2524 9.61441 17.3063 9.75H17.0625C17.0625 16.7401 17.0625 15.0068 17.0625 22H18.9375C18.9375 11.0276 18.9375 12.7975 18.9375 9.75H18.6937C18.7477 9.61438 18.8101 9.46344 18.8602 9.33619C19.5784 7.51381 19.8517 6.9375 20.8125 6.9375C21.5879 6.9375 22.2188 7.56831 22.2188 8.34375C22.2188 9.11919 21.5879 9.75 20.8125 9.75H19.875V13.5312H24.5938C25.3692 13.5312 26 12.9004 26 12.125V11.1562C26 10.3808 25.3692 9.75 24.5938 9.75Z",
    fill: "#3855B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3858_13066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(10 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBundlle);
export default __webpack_public_path__ + "static/media/icon-bundlle.e9d0d754dafa2d495dfb728028b810a9.svg";
export { ForwardRef as ReactComponent };